import type { RouteRecordRaw } from 'vue-router';

export const INBOUND_ROUTER: RouteRecordRaw[] = [
  {
    path: '/inbound',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/inbound/order-list',
    children: [
      {
        path: 'order-list',
        component: () => import('@/modules/movement/inbound/views/OrderInboundList.vue'),
        name: 'Order Inbound List',
        meta: {
          title: '입고 관리',
        },
      },
      {
        path: 'other-inbound',
        component: () => import('@/modules/movement/inbound/views/InboundCreate.vue'),
        name: 'Other Inbound Create',
        meta: {
          title: '기타입고 등록',
        },
      },
    ],
  },
];
